import * as d3 from "d3";

/**
 * Generic function to draw grouped elements.
 */
const drawElementGroups = ({
  container,
  data,
  classList = "",
  drawFn,
  onDrag,
  onClick,
}) => {
  const groups = container.selectAll(`g.${classList}`).data(data, (d) => d.id);

  //console.log("groups", data, classList);
  const enterGroups = groups
    .enter()
    .append("g")
    .attr("class", classList)
    .attr("data-id", (d) => d.id)
    .attr("cursor", "grab")
    .attr("pointer-events", "all")
    .attr("data-class", (d) => d.class)
    .attr("data-type", (d) => d.type)
    .on("click", (event, d) => {
      event.stopPropagation(); // Prevent event propagation
      //console.log("onClick", d);
      onClick(d);
    });

  // Use bindDataAndCallFunctions only for child elements (rect, line, etc.)
  enterGroups.each(function (d) {
    const groupContainer = d3.select(this);
    drawFn(groupContainer, d, onDrag);
    groupContainer.raise();
  });

  // Add an invisible rectangle to extended groups
  // to ensure the group is always clickable. I hate d3.
  if (
    classList.includes("case-refinement-group") ||
    classList.includes("part-refinement-group") ||
    classList.includes("part-repeat-group") ||
    classList.includes("subthread-group")
  ) {
    enterGroups
      .append("rect")
      .attr("width", (d) => d.size.width)
      .attr("height", (d) => d.size.height)
      .attr("x", 0) // Centers the rect around (0,0)
      .attr("y", -5)
      .attr("fill", "transparent")
      .attr("stroke", "transparent")
      .attr("stroke-width", 0)
      .attr("cursor", "grab")
      .attr("pointer-events", "all")
      .on("click", (event, d) => {
        event.stopPropagation(); // Prevent event propagation
        //console.log("onClick", d);
        onClick(d);
      });
  }

  groups
    .merge(enterGroups)
    .attr(
      "transform",
      (d) => `translate(${d.position?.x || 0}, ${d.position?.y || 0})`
    );

  groups.exit().remove();
};

export { drawElementGroups };
